import { useState } from 'react'

export default function DevLogin() {
  const [email, setEmail] = useState('dev@example.com')
  const [loading, setLoading] = useState(false)
  const isDev = (import.meta.env.VITE_APP_ENV || 'development') !== 'production'

  if (!isDev) return null

  const handleSignIn = async () => {
    setLoading(true)
    try {
      const resp = await fetch(`/api/v1/dev/token/${encodeURIComponent(email)}`)
      if (!resp.ok) {
        const txt = await resp.text()
        throw new Error(txt || 'Failed to get token')
      }
      const data = await resp.json()
      if (data.access_token) {
        localStorage.setItem('token', data.access_token)
        if (data.refresh_token) localStorage.setItem('refresh_token', data.refresh_token)
        localStorage.setItem('dev_user', email)
        // small delay to ensure token is stored then reload
        setTimeout(() => window.location.reload(), 100)
      } else {
        throw new Error('No access_token in response')
      }
    } catch (err: any) {
      console.error('Dev sign-in failed', err)
      alert('Dev sign-in failed: ' + (err.message || err))
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="flex items-center gap-2">
      <input
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="input input-sm"
        style={{ width: 220 }}
        title="Dev user email"
      />
      <button
        onClick={handleSignIn}
        className="btn btn-secondary text-sm"
        disabled={loading}
      >
        {loading ? 'Signing in...' : 'Dev Sign-in'}
      </button>
    </div>
  )
}
